import { Col, Navbar, Row } from "@/utils/bootstrap";
import CountryCodeSearch from "./CountryCodeSearch";
import SvgPhoneDrawerClose from "./SvgPhoneDrawerClose";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  code: string;
  setCode: (code: string) => void;
  onClose: () => void;
}

const CountryCodeHeader: React.FC<Props> = ({ code, setCode, onClose }) => {
  const t = useTranslation();
  return (
    <>
      <div style={{ marginTop: 138 }} />
      <Navbar className="country-code-header" fixed="top">
        <Row className="m-0 w-100" style={{ gap: 16 }}>
          <Row xs={12} className="w-100 m-0 p-0 d-flex align-items-center">
            <Col xs={4} className={`p-0 d-flex justify-content-start`}>
              <SvgPhoneDrawerClose onClick={onClose} />
            </Col>
            <Col
              xs={4}
              className={`p-0 justify-content-center text-nowrap title`}
            >
              {t.country_code}
            </Col>
            <Col xs={4} />
          </Row>
          <Col xs={12} className="p-0">
            <CountryCodeSearch searchTerm={code} setSearchTerm={setCode} />
          </Col>
        </Row>
      </Navbar>
    </>
  );
};

export default CountryCodeHeader;
